// src/services/logger.js
import store from "@/store";

export default {
  log(message) {
    console.log(message);
    store.dispatch("log", message);
  },
  info(message) {
    console.log(message);
    store.dispatch("log", message);
  },
  debug(message) {
    console.log(message);
    store.dispatch("log", message);
  },
  error(message) {
    console.log(message);
    store.dispatch("log", message);
  },
};
